export const CLASS_NAME = 'cst-insights-topbar'
